import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Card as BaseCard, TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Box = styled(({ children, display, flexWrap, justifyContent, padding, paddingLeft, width, ...props }) => (
  <div {...props}>{children}</div>
))`
  display: ${props => props.display};
  flex-wrap: ${props => props.flexWrap};
  flex-direction: ${props => props.flexDirection || 'initial'};
  justify-content: ${props => props.justifyContent || 'initial'};
  gap: ${props => props.gap || 'initial'};
  margin: ${props => props.margin || 'initial'};
  padding: ${props => props.padding};
  padding-left: ${props => props.paddingLeft};
  width: ${props => props.width};
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-content: ${props => props.alignContent};
  width: ${props => props.width};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign};
  && {
    background-color: ${props => props.theme.palette.brand.white};
  }
`

export const TableWrapper = styled('div')`
  & > div:first-child {
    width: 100%;
  }
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${props => props.direction || 'flex'};
`

export const Container = styled(({ children, display, float, width, ...props }) => (
  <BaseGrid container {...props}>
    {children}
  </BaseGrid>
))`
  padding: ${props => props.padding};
  &.MuiGrid-container {
    display: ${props => props.display};
    float: ${props => props.float};
    width: ${props => props.width};
  }
  ${props => props.theme.breakpoints.only('xs')} {
    justify-content: space-between;
  }
`
export const ContainerRef = styled('div')`
  width: ${props => props.width};
`

export const Column = styled(({ flexGrow, margin, width, ...props }) => <BaseGrid item {...props} />)`
  align-content: center;
  display: ${props => props.display};
  padding: ${props => props.padding};
`

export const CustomCard = styled(Card)`
  &.MuiPaper-root {
    border: 1px solid ${props => props.theme.palette.brand.gray2};
    border-radius: 4px;
    background: ${props => props.theme.palette.brand.white};
    ${props => props.theme.breakpoints.only('sm')} {
      margin: 0 0 30px 0;
    }
  }
`

export const Item = styled(({ children, width, ...props }) => (
  <BaseGrid item {...props}>
    {children}
  </BaseGrid>
))`
  &.MuiGrid-root {
    width: ${props => props.width};
  }
`

export const Logo = styled('img')`
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 215px;
  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 170px;
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  align-items: ${props => props.alignItems};
  flex-wrap: ${props => props.flexWrap};
  flex-direction: ${props => props.flexDirection};
  gap: ${props => props.gap};
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  max-width: ${props => props.MaxWidth};
  padding: ${props => props.margin};
  width: ${props => props.width};
`

export const ScrollButton = styled('button')`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: ${props => props.theme.palette.blue[50]};
  color: ${props => props.theme.palette.brand.white};
  border: none;
  border-radius: 50%;
  padding: 10px 15px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  opacity: ${props => (props.opacity ? 1 : 0)};
  visibility: ${props => (props.opacity ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s,
    visibility 0.3s;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 0.5rem 0;
  overflow: visible;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: 16px 15px 16px 0;
    text-align: ${props => props.textAlign};
    vertical-align: middle;
  }
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
